import './CarModelTextBlock.scss';

export default function CarModelTextBlock(data) {
  return (
    <div className={'container car-model-text-block'}>
      <div className={'purpose'} data-aos="fade-up">
        <span className={'purpose_headline'}>{data.fields.title.value}</span>
        <p
          className={'purpose_description'}
          dangerouslySetInnerHTML={{ __html: data.fields.text.value }}
        />
      </div>
    </div>
  );
}
